import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import { Checkboxes } from '../../../FlowConfigurationInputs';
import AutomService from '../../../../services/AutomService/AutomService';
import VariableService from '../../../../services/VariableService/VariableService'
import { MenuItem, Select } from '@material-ui/core';

function ProcessFlow({ action, variables, setOpenVariable, showAlert, findElementName, getAutomNamesIDs }) {
    const { t } = useTranslation();
    const [automs, setAutoms] = useState([]);
    const label = 'CONTENT.CONFIGURATION-FORM.AUTOMS.AUTOMFLOW.';
    const options = {
        dropdown: { data: automs, defaultValue: '' },
        checkboxes: { label: label + 'HIDDEN' }
    }
    const [selectedAutom, setSelectedAutom] = useState('');
    const [automVariables, setVariables] = useState([]);

    useEffect(() => {
        fetchData();
    }, [action]);

    const fetchData = async () => {
        const response = await AutomService.getAllAutoms();
        if (response?.status) {
            let data = [];
            for (const autom of response.data) {
                if (autom.type === 'Process') {
                    data.push({ label: autom.name, value: autom.id });
                }
            }
            setAutoms(data);
        }
        if (!action.fields.autom) { action.fields.autom = { value: '' }; setSelectedAutom(''); }
        else { handleChangeAutom(action.fields.autom.value); }
    };

    const fetchVariables = async (value) => {
        const response = await VariableService.getVariable(value, true);
        if (response?.status) {
            setVariables(response.data);
        }
    }

    const handleBlur = (event) => {
        if (findElementName(event.target.outerText)) {
            showAlert(t(label + 'SAME-NAME'));
        }
    }

    const handleChangeAutom = (value) => {
        setSelectedAutom(value);
        fetchVariables(value);
    }

    const handleChange = (event) => {
        action.fields.autom.value = event.target.value;
        handleChangeAutom(event.target.value);
    }

    return (
        <div>
            <div className="form-element">
                {t(label + 'PROCESS-NAME')}
                <TextInput action={action} inputName="elementName"
                    variables={variables} setOpenVariable={setOpenVariable}
                    onBlur={handleBlur}
                />
            </div>
            <div className="form-element" style={{ width: "90%" }}>
                {t(label + 'CHOOSE-PROCESS')}
                {/* <Dropdown action={action} inputName="autom" options={options.dropdown}/> */}
                <Select value={selectedAutom} onChange={handleChange} variant="outlined" fullWidth>
                    {automs.map((item, itemI) => <MenuItem key={itemI} value={item.value}>{item.label}</MenuItem>)}
                </Select>
            </div>
            {selectedAutom !== '' &&
                <div>
                    {automVariables.length > 0 ? <div style={{ fontSize: "12px", fontWeight: 700 }}>{t(label + 'INPUTS')}</div>
                        :
                        <div style={{ fontSize: "12px", fontWeight: 700, color: "#C4C4C4" }}>{t(label + 'NO-INPUT')}</div>}
                    {automVariables.map((item, itemI) =>
                        <div key={itemI} className="form-element">
                            {item.name}
                            <TextInput action={action} inputName={item.name}
                                variableType={item.type} variables={variables} />
                        </div>
                    )}
                </div>
            }
            <div className="form-element">
                <Checkboxes action={action} inputName="hidden" options={options.checkboxes} />
            </div>
        </div>
    );
}

export default ProcessFlow;
